export const MT_DECOMMISSION_REQUESTER = 'MT_DECOMMISSION_REQUESTER';
export const MT_DECOMMISSION_APPROVER = 'MT_DECOMMISSION_APPROVER';
export const MT_DECOMMISSION_FINAL_APPROVER = 'MT_DECOMMISSION_FINAL_APPROVER';
export const PROVISIONING_DECOMMISSION_SUBMITTED_BY = 'Provisioning Decommission Job';
export const PROVISIONING_DECOMMISSION_ACTOR = 'provisioning-automation';

export const ROLE_LABELS = {
    ST_FORM_FILLER: 'ST Form Filler',
    MT_FORM_FILLER: 'MT Form Filler',
    APPROVER: 'Approver',
    DEVOPS: 'DevOps',
    LICENSE_GENERATOR: 'License Generator',
    CAPACITY_READER: 'Capacity Reader',
    AGENT_CREATION: 'Agent Creation',
    [MT_DECOMMISSION_REQUESTER]: 'MT Decommission Requester',
    [MT_DECOMMISSION_APPROVER]: 'MT Decommission Approver',
    [MT_DECOMMISSION_FINAL_APPROVER]: 'MT Decommission Final Approver'
};

export function normalizeRoles(userRoles = []) {
    return (Array.isArray(userRoles) ? userRoles : []).map((r) => String(r).toUpperCase());
}

export function hasRole(userRoles, role) {
    return normalizeRoles(userRoles).includes(String(role).toUpperCase());
}

export function canAccessDecommissionTab(userRoles = []) {
    const roles = normalizeRoles(userRoles);
    return (
        roles.includes(MT_DECOMMISSION_REQUESTER) ||
        roles.includes(MT_DECOMMISSION_APPROVER) ||
        roles.includes(MT_DECOMMISSION_FINAL_APPROVER)
    );
}

export function canAccessDecommissionRequestSubTab(userRoles = []) {
    return hasRole(userRoles, MT_DECOMMISSION_REQUESTER);
}

export function canAccessDecommissionApprovalSubTab(userRoles = []) {
    return hasRole(userRoles, MT_DECOMMISSION_FINAL_APPROVER);
}

export function canAccessDecommissionSubApprovalSubTab(userRoles = []) {
    return hasRole(userRoles, MT_DECOMMISSION_APPROVER);
}

export function canSubApproveDecommission(userRoles = []) {
    return canAccessDecommissionSubApprovalSubTab(userRoles);
}

export function canExecuteDecommission(userRoles = []) {
    return canAccessDecommissionApprovalSubTab(userRoles);
}

export function canApproveDecommission(userRoles = []) {
    return canSubApproveDecommission(userRoles) || canExecuteDecommission(userRoles);
}

export function canCompleteDecommission(userRoles = []) {
    return canExecuteDecommission(userRoles);
}

export function getDefaultDecommissionSubTab(userRoles = []) {
    if (canAccessDecommissionRequestSubTab(userRoles)) return 'request';
    if (canAccessDecommissionSubApprovalSubTab(userRoles)) return 'subApproval';
    if (canAccessDecommissionApprovalSubTab(userRoles)) return 'approval';
    return 'request';
}

/** Requests created via provisioning tenantDeprovJob.sh (manager approval skipped). */
export function isProvisioningAutoDecommissionRequest(request) {
    if (!request) return false;

    const submittedBy = String(request.submittedBy || '').trim();
    const subApprovedBy = String(request.subApprovedBy || '').trim();
    const reason = String(request.decommissionReason || '').trim().toLowerCase();

    return (
        submittedBy === PROVISIONING_DECOMMISSION_SUBMITTED_BY ||
        subApprovedBy === PROVISIONING_DECOMMISSION_ACTOR ||
        reason.includes('provisioning decommission job')
    );
}

export function formatDecommissionSubmitterStatus(status) {
    if (!status) return 'Unknown';

    switch (String(status).toUpperCase()) {
        case 'PENDING_SUB_APPROVER':
        case 'PENDING_APPROVER':
            return 'Pending Manager Approval';
        case 'PENDING_DEVOPS_APPROVAL':
            return 'Pending Final Approval';
        case 'IN_PROGRESS':
            return 'Decommissioning';
        case 'FAILED':
            return 'Decommission Failed';
        case 'APPROVED':
            return 'Decommission Successful';
        case 'REJECTED':
            return 'Rejected';
        case 'CLOSED':
            return 'Closed — Not Eligible';
        default:
            return String(status)
                .replace(/_/g, ' ')
                .toLowerCase()
                .replace(/\b\w/g, (c) => c.toUpperCase());
    }
}

export function getDecommissionSubmitterStatusColor(status) {
    const normalized = String(status || '').toUpperCase();

    if (normalized === 'FAILED' || normalized === 'REJECTED' || normalized === 'CLOSED') {
        return 'negative';
    }
    if (normalized === 'APPROVED') {
        return 'positive';
    }
    if (
        normalized === 'PENDING_SUB_APPROVER' ||
        normalized === 'PENDING_APPROVER' ||
        normalized === 'PENDING_DEVOPS_APPROVAL' ||
        normalized === 'IN_PROGRESS'
    ) {
        return 'warning';
    }
    return '';
}
